import(/* webpackMode: "eager", webpackExports: ["ChallengesContent"] */ "/vercel/path0/src/components/shared/ChallengesContent.tsx");
